import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Admin/css/sidebar.css";
import { RxDashboard } from "react-icons/rx";
import { TbLockPassword } from "react-icons/tb";
import { BsCashCoin } from "react-icons/bs";
import { MdOutlineSpeakerNotes } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { FaBars, FaTimes } from "react-icons/fa";
import logoLight from "../Admin/logo/mathangi_logo.png";
import logoDark from "../Admin/logo/mlogo3.png";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark-theme")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("dark-theme"));
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const menus = [
    { name: "Dashboard", path: "/dashboard", icon: <RxDashboard /> },
    { name: "Profile", path: "/profile", icon: <CgProfile /> },
    { name: "Payment History", path: "/payment", icon: <BsCashCoin /> },
    {
      name: "Complaint Register",
      path: "/complaintregister",
      icon: <MdOutlineSpeakerNotes />,
    },
    {
      name: "Change Password",
      path: "/changepassword",
      icon: <TbLockPassword />,
    },
  ];

  useEffect(() => {
  setSidebarOpen(false);
}, [location.pathname]);

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        className="menu-btn"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        {sidebarOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div
          className="logo"
          onClick={() => navigate("/dashboard")}
          style={{ cursor: "pointer" }}
        >
          <img
            src={isDarkMode ? logoDark : logoLight}
            alt="Admin Logo"
            className="sidebar-logo"
          />
        </div>

        <ul>
          {menus.map((menu, index) => (
            <li key={index}>
              <Link
                to={menu.path}
                className={
                  location.pathname === menu.path ? "active" : ""
                }
                onClick={() => setSidebarOpen(false)}
              >
                <span className="icon">{menu.icon}</span>
                <span>{menu.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;